import Module from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/Module';
import PropertySettings from './PropertySettings.tsx';

export default PropertySettings;

export const PropertySettingsModule = new Module({
    moduleName: 'PropertySettings',
    title: 'Property Settings',
    route: 'property/:uuid/settings',
    paramList: ['uuid'],
    showNav: false,
    module: PropertySettings,
});

export const NewPropertySettingsModule = new Module({
    moduleName: 'NewPropertySettings',
    title: 'New Property',
    route: 'property/new',
    showNav: false,
    module: PropertySettings,
});
